import { useContext } from "react";
import { CourseContext } from "common/providers/CourseProvider";

export const useCourse = () => useContext(CourseContext);

export default useCourse;
